(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('exportsApp')
        .constant('CONST_EXPORTS', {
        	'EDIT_STATUS_CODE': "E",
        	'VIEW_STATUS_CODE': "V",
        	'REMOVE_STATUS_CODE': "R",
        	'CREATE_STATUS_CODE': "C",
        	'MODIFY_STATUS_CODE': "M",//Chỉnh sửa khi duyệt
        	'APPROVE_STATUS_CODE': "A",
        	'EDIT_STATUS_NAME': "Điều chỉnh phiếu đề nghị xuất hàng cho CN",
        	'VIEW_STATUS_NAME': "Xem phiếu đề nghị xuất hàng cho CN",
        	'REMOVE_STATUS_NAME': "Hủy phiếu đề nghị xuất hàng cho CN",
        	'CREATE_STATUS_NAME': "Tạo phiếu đề nghị xuất hàng cho CN",
        	'MODIFY_STATUS_NAME': "Điều chỉnh duyệt ĐN xuất hàng cho CN",//Chỉnh sửa khi duyệt
        	'APPROVE_STATUS_NAME': "Duyệt phiếu ĐN xuất hàng cho CN",
        	'APPROVE_TITLE':"DUYỆT XUẤT HÀNG/ĐIỀU PHỐI",
        	'CREATE_TITLE':"ĐỀ NGHỊ XUẤT HÀNG/ĐIỀU PHỐI",
        	'APPROVE_STATUS_VIEW': "approve",
        	'CREATE_STATUS_VIEW': "create",
        	'WAIT_IMPORT':"WAIT_IMPORT",
        	'URL_EXPORTS':"exports/#/exports",
        	'URL_EXPORTS_SEARCH':"exports/#/exportsSearch",
        	'SIGN_COLON':":",
        	'SIGN_SEMICOLON':";",
        	'VALUE_NULL':"",
        	'PARAM_STATUS':"status",
        	'PARAM_STOCK_TRANSFER_CODE':"stockTransferCode",
        	'PARAM_CREATE_DATE':"createdDate",
        	'PARAM_STOCK_REQUEST':"stockRequestId",
        	'PARAM_STOCK_TRANSFER':"stockTransferId"
        		
        });
})();
